import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import Field from '~/components/form-controls/Field';
import RadioGroup, {
  ButtonOption,
} from '~/components/form-controls/RadioGroup';
import Page from '~/components/layout/page/Page';
import {
  INPUT_NAME,
  useActionResult,
  useLoaderData,
} from './claimLineItemReason';

export default function ClaimLineItemReasonPage() {
  const {
    reasons,
    draftClaimLineItem: { reasonId: selectedReasonId },
  } = useLoaderData();
  const actionResult = useActionResult();

  return (
    <Page.Section title="What is the reason for your request?">
      <Form name="claimReason">
        <RadioGroup className="mt-2" label="Select a reason" showLabel={false}>
          {reasons.map((reason) => (
            <ButtonOption
              key={reason.id}
              value={reason.id}
              name={INPUT_NAME}
              defaultChecked={reason.id === selectedReasonId}
              required
            >
              {reason.name}
            </ButtonOption>
          ))}
        </RadioGroup>
        {actionResult?.ok === false && (
          <Field.ErrorText>{actionResult.message}</Field.ErrorText>
        )}
        <Submit>Next</Submit>
      </Form>
    </Page.Section>
  );
}
